export function ErrorBanner({ message }: { message: string }) {
  return (
    <div className="rounded-lg border border-accent-red/40 bg-accent-red/10 px-4 py-3 text-sm text-accent-red">
      ⚠ {message}
    </div>
  )
}
